module.exports = __webpack_public_path__ + "img/swiper1_m.00113197.png";